export default __webpack_public_path__ + "static/media/LF-3Open.00536f12.png";